import TemporaryItemsService from "../TemporaryItemsService";
import TemporaryItemsSearch from "../TemporaryItemsSearch.model";
import _ from "lodash";
import {SOURCE_TEMPORARY_ITEMS_TABLE, TEMPORARY_ITEMS_TABLE_NAME} from "@/modules/constants";
import i18n from "../../../../shared/i18n";
import Vue from "vue";
import {store} from "../../../../plugins/vuex";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 5,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new TemporaryItemsSearch(),
    extraFilters: {},
    expand: 'bucket_images',
    toggleColumns: {
      fields: [...getDefaultFieldData(), ...differentFields],
      requiredFields: ['reserve'],
      dynamicFields: [],
      defaultFields: ['image', 'title', 'message', 'customer', 'low', 'quantity', 'reserve', 'receive_date', 'archived_at', 'progress', 'potential']
    }
  }
};

let getDefaultFieldData = () => {
  return [
    {key: 'customer', label: i18n.t('Customer'), sortable: true, tdClass: 'customer-col', isVisible: true, expand: 'customer'},
    {key: 'image', label: i18n.t('Image'), sortable: false, tdClass: 'thumbnail-img-holder', isVisible: true, expand: 'images'},
    {key: 'title', label: i18n.t('Title'), sortable: true, tdClass: 'title-col', isVisible: true, expand: ''},
    {key: 'message', label: i18n.t('Message'), sortable: true, tdClass: 'message-col', isVisible: true, expand: ''},
    {key: 'low', label: i18n.t('Estimate'), sortable: true, tdClass: 'estimate-col', isVisible: true, expand: ''},
    {key: 'quantity', label: i18n.t('Quantity'), sortable: true, tdClass: 'quantity-col', isVisible: true, expand: ''},
    {key: 'reserve', label: i18n.t('Reserve'), sortable: true, tdClass: 'reserve-col', isVisible: true, expand: ''},
    {
      key: 'receive_date',
      label: i18n.t('Receive Date'),
      sortable: true,
      tdClass: 'receive-date-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'archived_at',
      label: i18n.t('Archived At'),
      sortable: true,
      tdClass: 'archived-at-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'progress',
      label: i18n.t('Progress'),
      sortable: true,
      tdClass: 'progress-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'potential',
      label: i18n.t('Potential'),
      sortable: true,
      tdClass: 'potential-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'department',
      label: i18n.t('Department'),
      sortable: true,
      tdClass: 'department-col',
      isVisible: false,
      expand: 'department'
    },
    {
      key: 'tax_status',
      label: i18n.t('Tax Status'),
      sortable: true,
      tdClass: 'tax-status-col',
      isVisible: false,
      expand: 'tax_status'
    },
    {
      key: 'category',
      label: i18n.t('Category'),
      sortable: true,
      tdClass: 'category-col',
      isVisible: false,
      expand: 'category'
    },
    {
      key: 'item_location',
      label: i18n.t('Item Location'),
      sortable: true,
      tdClass: 'item-location-col',
      isVisible: false,
      expand: 'item_location'
    },
    {
      key: 'start_price',
      label: i18n.t('Start Price'),
      sortable: true,
      tdClass: 'start-price-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'collection_info',
      label: i18n.t('Collection Information'),
      sortable: false,
      tdClass: 'collection-info-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'created_data',
      label: i18n.t('Created at / Created by'),
      sortable: false,
      tdClass: 'created-data-col',
      isVisible: false,
      expand: 'created_by'
    },
    {
      key: 'updated_data',
      label: i18n.t('Updated at / Updated by'),
      sortable: false,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'updated_by'
    },
    {
      key: "specialists",
      label: i18n.t('Specialists'),
      sortable: false,
      tdClass: 'specialists-col',
      isVisible: false,
      expand: 'specialists'
    },
    {
      key: "reserve_type",
      label: i18n.t('Reserve Type'),
      sortable: true,
      tdClass: 'reserve_type-col',
      isVisible: false
    },
  ]
};

export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      activeInventoryItems: getDefaultTableData(),
      archivedInventoryItems: getDefaultTableData(),
    },
    temporaryItemsApproveModal: {
      show: false,
      object: null,
      source: null
    },
    modal: {
      error: null,
      loading: false,
      show: false,
      object: null,
      source: null
    },
    archiveMessageModal: {
      loading: false,
      show: false,
      uuids: null
    }
  },
  actions: {
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new TemporaryItemsSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await TemporaryItemsService.getTemporaryItems(params);
      const results = response.body.results
      const modifiedResults = results.map(item => {
        item.images = item.bucket_images
        return item;
      })
      commit('updateTableLoading', false);
      if (response.success) {
        commit('updateTableData', {
          rows: modifiedResults,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    updateInventoryTablePage({state}, page) {
      state.tableData[state.tableSource].pagination.page = page;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${TEMPORARY_ITEMS_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
          .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
          .map(c => c.expand)
          .join(',')

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async moveArchived({dispatch}, data) {
      let response = await TemporaryItemsService.moveArchived(data)
      if (response.success) {
        dispatch('getTableData')
      }
      return response
    },
    showTemporaryItemsApproveModal({commit}, {object, source}) {
      commit('showTemporaryItemsApproveModal', {object: _.cloneDeep(object), source});
    },
    hideTemporaryItemsApproveModal({commit}) {
      commit('hideTemporaryItemsApproveModal');
    },
    async approveItems({dispatch}, data) {
      let response = await TemporaryItemsService.approveItems(data);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async getModalObject({commit, state}, {uuid, source}) {
      let response = await TemporaryItemsService.getTemporaryItem(uuid, [
        'department',
        'customer.shipping_address',
        'item_location',
        'category.dynamic_fields_template',
        'expert_user',
        'rep_user',
        'images',
        'bucket_images',
        'specialists',
      ].join(','));

      if (response.success) {
        let it = response.body
        it.specialists_uuids = []
        if (it.specialists && it.specialists.length > 0) {
          it.specialists_uuids = it.specialists.map(s => s.uuid)
        }
        it.images = it.bucket_images
        commit('updateModalObject', {object: _.cloneDeep(it), source})
      } else {
        state.modal.error = response.toastError;
      }
    },
    async showModal({commit}, {object = null, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    async hideModal({commit}) {
      commit('hideModal');
    },
    async updateTemporaryItem({commit, state}, inventory) {
      let response = await TemporaryItemsService.updateTemporaryItem(inventory.uuid, inventory, 'customer.shipping_address,images,specialists');
      if (response.success && state.modal.source === SOURCE_TEMPORARY_ITEMS_TABLE) {
        commit('updateTemporaryItem', response.body);
      }
      return response;
    },
    async createTemporaryItem({dispatch, state}, inventory) {
      let response = await TemporaryItemsService.createTemporaryItem(inventory, 'images,specialists');
      if (response.success && state.modal.source === SOURCE_TEMPORARY_ITEMS_TABLE) {
        dispatch('getTableData');
      }
      return response;
    },
    updateTemporaryItemLocally({commit}, temporaryItem) {
      commit('updateTemporaryItem', temporaryItem)
    },
    showArchiveMessageModal({commit}, {uuids, source}) {
      commit('showArchiveMessageModal', {uuids: _.cloneDeep(uuids), source});
    },
    hideArchiveMessageModal({commit}) {
      commit('hideArchiveMessageModal');
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: (state) => {
      state.modal.show = false;
      state.modal.error = null;
    },
    updateTemporaryItem: (state, item) => {
      const index = state.tableData[state.tableSource].rows.findIndex(i => i.uuid === item.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...item};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateUpcomingSales: (state, payload) => state.tableData[state.tableSource].upcomingSales = payload,
    changeCurrentInventoryLoading: state => state.view.loading = !state.view.loading,
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    showTemporaryItemsApproveModal: (state, {object, source}) => {
      state.temporaryItemsApproveModal.show = true;
      state.temporaryItemsApproveModal.object = object;
      state.temporaryItemsApproveModal.source = source;
    },
    hideTemporaryItemsApproveModal: state => state.temporaryItemsApproveModal.show = false,
    showArchiveMessageModal: (state, {uuids, source}) => {
      state.archiveMessageModal.show = true;
      state.archiveMessageModal.uuids = uuids;
      state.archiveMessageModal.source = source;
    },
    hideArchiveMessageModal: state => {
      state.archiveMessageModal.show = false
      state.archiveMessageModal.uuids = null
    },
    updateModalObject: (state, {object, source}) => {
      state.modal.object = object;
      state.modal.source = source;
    },
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  },
}
